var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"test-report"},[_c('base-table',{ref:"table",attrs:{"url":"/testReport/get","toolbar":_vm.toolbar,"columns":_vm.columns}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }